<template>
  <div class="login-wrap">
    <div class="login-box">
      <div class="login-inner">
        <div class="each-cell">
          <div class="cell-01 user-cell">
            <input id="num" class="log-inp" type="text" placeholder="请输入用户名"  autocomplete="off"/>
          </div>
        </div>
        <div class="each-cell">
          <div class="cell-01 psw-cell">
            <input id="psw" class="log-inp" type="password" onfocus="this.type='password'" placeholder="请输入密码"  autocomplete="off"/>
          </div>
        </div>
        <div class="each-cell clear">
          <div class="cell-02 account-cell fl">
            <input id="yzm" class="log-inp" type="text" placeholder="请输入验证码"  autocomplete="off"/>
          </div>
          <div class="cell-03 fr">
            <div id="myCanvas"></div>
          </div>
        </div>
        <!-- <div class="each-cell">
            <input class="remind-name" type="checkbox"/><label>记住账号</label> -->
        <!--<a class="forget-psw" href="">忘记密码？</a>-->
        <!-- </div> -->
        <div class="each-cell" >
          <input class="log-btn" type="button" value="登录" id="loginBtn"/>
        </div>
      </div>
    </div>
    <div class="login-bot"><p>{{copyright.paramtype}}：{{copyright.paramcode}}</p>&nbsp;&nbsp;&nbsp;&nbsp;<p>{{echnicalSupport.paramtype}}：{{echnicalSupport.paramcode}}</p></div>
  </div>
</template>
<style lang="less" scoped>
  /* 大屏幕 ：大于等于1200px*/
  @media (min-width: 1200px) { }
  @media (min-width: 1200px) and (max-width: 1300px) {
	.login-tit {
      display: block;
      min-width: 1200px;
      margin: 50px auto 0;
      border: none;
    }
	 }
  /*默认*/
  @media (min-width: 980px){
    .login-tit {
      display: block;
      margin: 50px auto 0;
      border: none;
    }
  }

  /* 平板电脑和小屏电脑之间的分辨率 */
  @media (min-width: 768px) and (max-width: 979px) {  }

  /* 横向放置的手机和竖向放置的平板之间的分辨率 */
  @media (max-width: 767px) {
    .login-tit {
      display: block;
      width: 360px;
      margin: 50px auto 0;
      border: none;
    }
  }

  /* 横向放置的手机及分辨率更小的设备 */
  @media (max-width: 480px) { }
  body {
    min-height: 400px;
    min-width: 500px;
  }
  .login-wrap {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url('../../static/images/login/背景.png');
     /*background-image: url('../../static/images/login/第十师灌区信息化业务应用系统.png');*/
    background-size: 100% 100%;
    /*min-height: 600px;*/
    /*min-width: 1280px;*/
    overflow: hidden;
  }
  .login-wrap h1 {
    font-size: 36px;
    text-align: center;
    color: #fdfdfd;
    margin-top: 80px;
    text-shadow: 5px 5px 4px #666;
    letter-spacing: 5px;
  }
  .login-tit {
    display: block;
    width: 600px;
    height: 70px;
    margin: 50px auto 0;
    border: none;
  }
  .login-box {
  	height: 25%;
    position: absolute;
    top: 26%;
    left: 49%;
    width: 23%;
    border: 1px solid rgba(255,255,255,.3);
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    /*background-color: rgba(0,0,0,.4);*/
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#66000000,endColorstr=#66000000);
    padding-top: 50px;
    padding-bottom: 45px;
    /*margin: 50px auto 0;*/
  }
  .login-title {
    position: absolute;
    top: 0px;
    left: 40px;
    color: #508BFA;
    /*margin-left: -96px;*/
   text-align: left;
    width: 90%;
    height: 72px;
    /* background-image: url("../img/login-logo.png"); */
  }
  .login-inner {
  	height: 100%;
    margin-left: 40px;
    margin-right: 40px;
  }
  .login-inner>p {
    color: #f5881e;
    font-size: 22px;
    margin-top: 20px;
  }
  .each-cell {
    width: 100%;
    margin-top: 20px;
  }
  .cell-lab {
    width: 70px;
    line-height: 48px;
    color: #fff;
    font-size: 16px;
  }
  .cell-01,
  .cell-02 {
    box-sizing: border-box;
    height: 48px;
    line-height: 48px;
    border: 1px solid #fff;
    /*border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;*/
    background-color: #fff;
    background-image: url("../../static/images/login/login-icon.png");
    background-repeat: no-repeat;
    padding-left: 43px;
  }
  .cell-01 {
    // margin-left: 70px;
    border: 1px solid #508BFA;
  }
  .cell-02 {
    width: 170px;
    /*margin-left: 70px;*/
  }
  .user-cell {
    background-position: 8px 13px;
  }
  .psw-cell {
    background-position: 8px -54px;
  }
  .account-cell {
    background-position: 10px -117px;
  }
  .log-inp {
    height: 25px;
    border: none;
    width: 80%;
    outline:medium;
    font-size: 14px;
    color: #666;
    background: #fff;
  }
  input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {
	-webkit-text-fill-color: #000 !important;
	-webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;
    background-color:transparent;
    background-image: none;
     transition: background-color 50000s ease-in-out 0s;
}
input {
	 background-color:transparent;
}
  #myCanvas {
    box-sizing: border-box;
    border: 1px solid #bac7d2;
    background-color: #fff;
    width: 100px;
    height: 48px;
    line-height: 48px;
    font-size: 25px;
    color: #4984ee;
    text-align: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    letter-spacing: 2px;
  }
  .remind-name {
    // margin-left: 70px;
    margin-right: 5px;
    vertical-align: -3px;
  }
  .remind-name+label {
    color: #fff;
    font-size: 12px;
  }
  .forget-psw {
    color: #fff;
    margin-left: 20px;
  }
  .forget-psw:hover {
    color: blue;
    text-decoration: underline;
  }
  .log-btn {
    width: 100%;
    height: 50px;
    cursor: pointer;
    background-color: #3a76e2;
    font-size: 14px;
    color: #fff;
    border: none;
    /*border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;*/
    // margin-left: 70px;
  }
  .bg-cho {
    position: absolute;
    top: 40px;
    right: 130px;
    width: 40px;
    height: 40px;
    border: 2px solid rgba(255,255,255,.5);
    background-color: rgba(20,68,163,.8);
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#C81444a3,endColorstr=#C81444a3);
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    /* background-image: url("../img/share.png"); */
    background-repeat: no-repeat;
    background-position: center;
  }
  .bg-cho-wrap {
    position: absolute;
    left: 50%;
    margin-left: -98px;
    top: 40px;
  }
  .bg-cho-box {
    display: none;
    position: absolute;
    top: 10px;
    padding: 4px 10px;
    border: 1px solid rgba(255,255,255,.5);
    background-color: rgba(20,68,163,.8);
    filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#C81444a3,endColorstr=#C81444a3);
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
  }
  .bg-cho-box em {
    position: absolute;
    top: -10px;
    left: 50%;
    width: 11px;
    height: 11px;
    margin-left: -5px;
    /* background-image: url("../img/trangle.png"); */
    background-repeat: no-repeat;
  }
  .bg-cho-box ul {
    width: 180px;
    margin-left: -4px;
  }
  .bg-cho-box ul li {
    margin-left: 2px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    cursor: pointer;
    border: 2px solid ;
    border-color: transparent;
    overflow: hidden;
  }
  .bg-cho-box ul li img {
    display: block;
  }
  .active {
    border-color: #2659bc !important;
  }
  .login-bot {
    position: absolute;
    bottom: 20px;
    width: 100%;
    font-size: 12px;
    text-align: center;
    color: #fff;
  }
  .login-bot>p{
    display:inline-block;
  }
</style>
<script>
  import {login,getcopyright} from '@/apis/api'
	import { fetchData, getallstationkind } from '@/apis/api'
  import { mapMutations } from 'vuex'
  export default {
    data() {
      return {
        return_PIN:'',
        echnicalSupport:{},
        copyright:{},
      }
    },
    methods: {
      ...mapMutations(['CHANGEUSERINFO']),
      getAllStationKind() {
        getallstationkind().then((res) => {
          if(res.code == 1) {
            //  	 		console.log(res.result,192837)
            sessionStorage.setItem('stationType', JSON.stringify(res.result))
          }
        }).catch((err) => {
          this.$message({
            message: '服务请求失败！',
            type: 'warning'
          })
        })
      },
      //绘制验证码
      drawPIN() {
        var _this = this;
        var canvas = $('#myCanvas');
        try {
          //得到四个随机字母、数字
          function getabc() {
              var _str = "A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,1,2,3,4,5,6,7,8,9";
              var _str_array = _str.split(",");
              _this.return_PIN = "";
              for (var i = 0; i < 4; i++) {
                  var _rnd = Math.floor(Math.random() * _str_array.length);
                  _this.return_PIN += _str_array[_rnd];
              };
          };
          function write_text(_str) {
            canvas.html(_str);
          }
          getabc();
          write_text(this.return_PIN);
        } catch (e) {
          console.log(e);
        }
      },
      //验证输入信息是否为空
      checkIsEmpty() {
        var num = $("#num").val();
        var psw = $("#psw").val();
        var yzm = $("#yzm").val();

        if(num == "") {
          this.$notify({
            title: '提示',
            message: '用户名不能为空，请输入!',
            type: 'warning'
          });
          $("#yzm").val('');
        }else if(( /\s/).test(num)){
          this.$notify({
            title: '提示',
            message: '用户名存在空格!',
            type: 'warning'
          });
        }else if (psw == "") {
          this.$notify({
            title: '提示',
            message: '密码不能为空，请输入！',
            type: 'warning'
          });
          $("#yzm").val('');
        }else if(( /\s/).test(psw)){
          this.$notify({
            title: '提示',
            message: '密码存在空格！',
            type: 'warning'
          });
        }else if (yzm == "") {
          this.$notify({
              title: '提示',
              message: '验证码不能为空，请输入！',
              type: 'warning'
          });
          $("#yzm").val('');
        }else if(( /\s/).test(yzm)){
          this.$notify({
            title: '提示',
            message: '验证码存在空格！',
            type: 'warning'
          });
        }else {
          return this.checkPIN();
        }
        this.drawPIN();
      },
      //判断输入的验证码是否一致
      checkPIN () {
        var num = $("#num").val();
        var psw = $("#psw").val();
        var _val = $("#yzm").val().toUpperCase();

        if (_val == this.return_PIN.toUpperCase()) {
          $("#yzm").val('');
          //记住用户名勾选状态操作
          // this.remindName();
          //登录请求
          this.verifyRequest(num,psw);
        } else {
          $("#yzm").val('');
          //重绘验证码
          this.drawPIN();
          this.$notify({
            title: '提示',
            message: '您输入的验证码不正确！',
            type: 'warning'
          });
        }
      },
      verifyRequest(num,psw) {
        var params = {
          loginname: num,
          password: psw
        }
        login(params).then((res) => {
          if(res.code == '1') {
            this.CHANGEUSERINFO(res.result);
              //跳转到首页
              this.$router.push('main')
          }else {
              this.$message({
                message: res.message || '用户名或密码错误！',
                type: 'error'
              });
          }
        }).catch((err) => {
          console.log(err);
          this.$message({
            message: '服务请求失败！',
            type: 'warning'
          });
        })
      },
      getCopyRight(){
	      getcopyright().then((res) => {
		      this.copyright=res.result.copyright[0]
		      this.echnicalSupport=res.result.echnicalSupport[0]
		    }).catch((err) => {
          console.log(err);
          this.$message({
              message: '服务请求失败！',
              type: 'warning'
          });
        })
      }
    },
    mounted() {
      this.getAllStationKind()
      this.getCopyRight()
      var _this = this;
      this.drawPIN();
      $('#myCanvas').click({content:this},function (e){
          e.data.content.drawPIN();
      });
      $('#loginBtn').click({content:this},function (e){
        console.log(11)
        e.data.content.checkIsEmpty();
      });

      document.onkeydown=function(e){
        var key=window.event.keyCode;
        if(key==13){
            _this.checkIsEmpty();
        }
      }
    },
    beforeDestroy() {
      document.onkeydown=function(e){
        var key=window.event.keyCode;
        if(key==13){

        }
      }
    },
  }
</script>




// WEBPACK FOOTER //
// src/sysmodule/login.vue